
export default class Cover {
	constructor(el) {
		this.el = el;
		if (document.querySelector('.home-cover__placeholder')) {
			this.trigger = document.querySelector('.home-cover__cover_trigger');
			this.home = document.querySelector('.home-cover');
			//this.events();
			window.addEventListener('scroll', this.checkCoverTrigger.bind(this, this.trigger));
		}
	}
	checkCoverTrigger(el, e) {
		//console.log(this.trigger.getBoundingClientRect().top );
		if (this.trigger.getBoundingClientRect().top <= 0) {
			this.home.classList.remove('fixed');
		} else {
			this.home.classList.add('fixed');
		}
		if (this.trigger.getBoundingClientRect().top <= (window.innerHeight / 2)) {
			this.home.classList.add('reveal');
		}
	}
}